'use client';
import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'blue' | 'white' | 'muted';
  label?: string;
  className?: string;
}

const SIZE_MAP = {
  sm: 'spinner-sm',
  md: 'spinner-md',
  lg: 'spinner-lg',
  xl: 'spinner-xl',
};

const VARIANT_MAP = {
  blue: '',
  white: 'spinner-white',
  muted: 'spinner-muted',
};

export default function LoadingSpinner({
  size = 'md',
  variant = 'blue',
  label,
  className = '',
}: LoadingSpinnerProps) {
  return (
    <div className={`inline-flex flex-col items-center justify-center gap-2 ${className}`}>
      <div
        className={`spinner ${SIZE_MAP[size]} ${VARIANT_MAP[variant]}`}
        role="status"
        aria-label={label ?? 'Loading…'}
      />
      {label && (
        <span className="text-xs font-semibold text-blue-600 animate-pulse-soft">
          {label}
        </span>
      )}
    </div>
  );
}
